module.exports = __webpack_public_path__ + "img/hot-deals.5e86d8c4.jpg";